module.exports = __webpack_public_path__ + "static/media/clock.a172edca.svg";